import React, { useState } from "react";
import CustomButton from "../../../components/Commons/Button/CustomButton";
import BoxedInput from "../../../components/Commons/CustomForm/BoxedInput";
import Loader from "../../../components/Commons/Loader/Loader";
import style from "./OTPPopup.module.css";
import { apiFormatPostFullCtrlInjson } from "../../../Api/ApiFormat";
import swal from "sweetalert";

function OTPPopup({
  close,
  loginFunc,
  isLoading,
  Password,
  deviceId,
  Username,
}) {
  const [OTP, setOTP] = useState("");
  const [isValidOTP, setisValidOTP] = useState(false);
  const [ShowErrOnBlur, setShowErrOnBlur] = useState(false);

  const submitOtp = async () => {
    const apiResp = await apiFormatPostFullCtrlInjson("api/user/submitOTPV1", {
      Username: Username,
      MobileNo: deviceId,
      source: "Web",
      Password: Password,
      OTP: OTP,
    });
    if (apiResp) {
      if (apiResp.data.errorCode === "200") {
        loginFunc();
      } else {
        swal("Oops!", "Incorrect OTP", "error");
      }

    }
  };
  return (
    <div className="main_popup">
      <div className={`main_popup_card ${style.card}`}>
        {isLoading && <Loader />}

        <div lassName={style.tpin}>
          <BoxedInput
            value={OTP}
            setter={setOTP}
            label={"Enter Your OTP"}
            name={"OTP"}
            length={4}
            isValid={setisValidOTP}
            showErrOnBlur={ShowErrOnBlur}
            setShowErrOnBlur={setShowErrOnBlur}
          />
        </div>

        <div className={`${style.buttonWrapper}`}>
          <CustomButton
            txt={"Cancel"}
            OnClickFunc={() => {
              close();
            }}
            type="Cancel"
          />
          <CustomButton
            txt={"Submit"}
            OnClickFunc={() => {
              if (isValidOTP) {
                submitOtp();
              } else {
                setShowErrOnBlur(true);
              }
            }}
            type="Submit"
          />
        </div>
      </div>
    </div>
  );
}

export default OTPPopup;
